import { render, staticRenderFns } from "./edit-shape.vue?vue&type=template&id=2cba827b&scoped=true"
import script from "./edit-shape.vue?vue&type=script&lang=js"
export * from "./edit-shape.vue?vue&type=script&lang=js"
import style0 from "./edit-shape.vue?vue&type=style&index=0&id=2cba827b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba827b",
  null
  
)

export default component.exports